import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getClientTimelineStatus = () => {
    return httpClient.get(server.CLIENT_TIMELINE_STATUS);
};
export const getClientTimelineStatusByID = (id) => {
    return httpClient.get(server.CLIENT_TIMELINE_STATUS + `/${id}`);
};
export const createClientTimelineStatus = (data) => {
    return httpClient.post(server.CLIENT_TIMELINE_STATUS + `/`, data);
};
export const updateClientTimelineStatus = (id, data) => {
    return httpClient.put(server.CLIENT_TIMELINE_STATUS + `/${id}`, data);
};
export const deleteClientTimelineStatus = (id) => {
    return httpClient.delete(server.CLIENT_TIMELINE_STATUS + `/${id}`);
}